import styled from 'styled-components'
import { Button } from '../../atoms'

export const HeaderContainer = styled.header`
  background: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
  min-height: 48px;
  position: relative;
  z-index: 10;

  @media (max-width: 768px) {
    min-height: 0px;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding: 8px 12px;
    gap: 8px;
  }
`

export const PropertyInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
  min-width: 0;
`

export const RadarChartContainer = styled.div`
  flex-shrink: 0;
`

export const RadarContainer = styled.div`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 10px;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`

export const PropertyDetails = styled.div`
  flex: 1;
  min-width: 0;
`

export const PropertyTitle = styled.h1<{ $editable?: boolean }>`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 16px;
    white-space: normal;
  }

  ${({ $editable }) =>
    $editable &&
    `
    display: inline-block;
    cursor: text;
    border-bottom: 1px dashed transparent;
    transition: border-color 0.2s;

    &:hover {
      border-bottom-color: #ccc;
    }
  `}
`

export const EditableTitle = styled.input`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  background: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 0;
  margin: 0 0 2px 0;
  width: 100%;
  max-width: 400px;
  outline: none;
  font-family: inherit;
`

export const PropertyMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    font-size: 11px;
    gap: 4px;
  }
`

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
`

export const PropertyTags = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    display: none;
  }
`

export const PropertyActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin: 0 -12px;
    padding: 4px 12px;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const ActionGroup = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-shrink: 0;
    flex-wrap: nowrap;
    gap: 6px;
  }
`

export const HeaderActions = styled.div`
  display: flex;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-shrink: 0;
  }
`

export const ActionButtonLabel = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`

export const ActionButtonCount = styled.span`
  font-size: 10px;
  padding: 1px 4px;
  background: #f5f5f5;
  border-radius: 8px;
  font-weight: 500;

  @media (max-width: 768px) {
    position: absolute;
    top: -4px;
    right: -4px;
    font-size: 9px;
    padding: 1px 4px;
    min-width: 14px;
    text-align: center;
    background: #0294df;
    color: white;
  }
`

export const ActionBtn = styled(Button)<{ $active?: boolean }>`
  background: ${({ $active }) => ($active ? '#e6f4fc' : 'white')};
  border: 1px solid ${({ $active }) => ($active ? '#0294df' : '#e5e5e5')};
  color: ${({ $active }) => ($active ? '#0294df' : '#6b6b6b')};
  padding: 6px 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    position: relative;
    padding: 3px 8px;
    font-size: 10px;
    gap: 3px;
  }
`

export const PrimaryActionBtn = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    position: relative;
    padding: 3px 8px;
    font-size: 10px;
    gap: 3px;
  }
`

export const PrimaryActionCount = styled.span`
  font-size: 10px;
  padding: 1px 6px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  font-weight: 600;

  @media (max-width: 768px) {
    position: absolute;
    top: -4px;
    right: -4px;
    font-size: 9px;
    padding: 1px 4px;
    min-width: 14px;
    text-align: center;
  }
`
